function dropdownPricingContent() {
	$(".subscriptionsDropdown__select").on("click", function() {
		var pricingCard = $(this).closest('.subscriptionsCard');
		var pricingIndex = $(this).index();
		var pricingSet = $(this)
			.parent()
			.siblings(".subscriptionsDropdown__indicator");
		var pricingSetCost = $(pricingSet).find(".subscriptionsSetCost");
		var pricingSetTerm = $(pricingSet).find(".subscriptionsSetTerm");
		var pricingGetCost = $(this)
			.find(".subscriptionsGetCost")
			.attr("data-subscriptions-cost");
		var pricingGetTerm = $(this)
			.find(".subscriptionsGetTerm")
			.attr("data-subscriptions-term");
		var pricingDropdownContent = $(this).parent(".dropdownContent");
		var pricingDropdownTrigger = $(this)
			.parent()
			.siblings(".dropdownTrigger");
		$(pricingSetCost).attr("data-subscriptions-cost", pricingGetCost);
		$(pricingSetTerm).attr("data-subscriptions-term", pricingGetTerm);
		pricingDropdownContent.removeClass("is-open");
		pricingDropdownTrigger.removeClass("open");
		if (pricingIndex > 0) {
			pricingCard.addClass("plan-has-discount")
		} else {
			pricingCard.removeClass("plan-has-discount")
		}
	});
}